module.exports = __webpack_public_path__ + "static/media/29ADMSPC5.e3bdd8b0.jpg";